import React, { useEffect } from 'react';
import img from "./image 33.png";
import img2 from "./image 35.png"


const Services = () => {
  useEffect(() => {
    
    const handleMouseMove = (e) => {
      document.querySelectorAll('.industry-card').forEach(card => {
        const rect = card.getBoundingClientRect();
        const x = e.clientX - rect.left;
        const y = e.clientY - rect.top;

        
        card.style.setProperty('--x', `${x}px`);
        card.style.setProperty('--y', `${y}px`);
        card.style.setProperty('--size', '750px');
      });
    };

    const handleMouseLeave = () => {
      document.querySelectorAll('.industry-card').forEach(card => {
        card.style.setProperty('--size', '0px');
      });
    };

    
    document.querySelectorAll('.industry-card').forEach(card => {
      card.addEventListener('mousemove', handleMouseMove);
      card.addEventListener('mouseleave', handleMouseLeave);
    });

   
    return () => {
      document.querySelectorAll('.industry-card').forEach(card => {
        card.removeEventListener('mousemove', handleMouseMove);
        card.removeEventListener('mouseleave', handleMouseLeave);
      });
    };
  }, []); 

  return (
    <main className="container-fluid p-0">
    <section className="endustry-section">
      <div className="endustry-container">
        <div className="row align-items-center">
          <div className="col-md-6">
            <div className="endustry-img">
              <img src={img} alt="Healthcare" />
            </div>
          </div>
          <div className="col-md-6">
            <div className="endustry-text">
              <h6 className="card-desc-md">Healthcare</h6>
              <p>
                Our skilled customer service teams, with deep industry knowledge, leverage cutting-edge BPO services and
                technology solutions. This enables us to consistently deliver exceptional collections, recovery, and
                revenue generation results for media and entertainment clients, while optimizing system efficiency and
                protecting your brand’s reputation.
              </p>
            </div>
          </div>
        </div>

        <div className="row align-items-center">
          <div className="col-md-6">
            <div className="endustry-text">
              <h6 className="card-desc-md">Telecommunication</h6>
              <p>
                We combine deep domain expertise with cutting-edge BPO services and technology solutions to deliver exceptional
                financial results for telecommunications providers. By utilizing a consultative approach and leveraging
                industry-specific platforms, we maximize recoveries, increase revenue, and ensure a seamless customer service
                experience that safeguards your reputation.
              </p>
            </div>
          </div>
          <div className="col-md-6">
            <div className="endustry-img">
              <img src={img2} alt="Telecommunication" />
            </div>
          </div>
        </div>
      </div>
    </section>
  </main>
  );
};

export default Services;
